import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserPermissionsService } from '@shared/services/userpermissions.service';
import { sidebarItems } from '../print/menu';

/**
 * Redirects the bare `/print` entry to the first Print sidebar item the current user has permission for. The Print top-nav button lands here (rather than a hardcoded child) so the default landing page can be chosen based on the user's permissions and available sidebar items, instead of always navigating to a single
 * child route.
 *
 * Only acts on the exact `/print` path; navigations to a specific child pass through untouched so each child's own PermissionGuard still applies.
 */
export const PrintLandingGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
	const url = state.url.split('?')[0].replace(/\/$/, '');
	if (url !== '/print') {
		return true;
	}

	const userPermissions = inject(UserPermissionsService);
	const router = inject(Router);

	const firstAllowed = sidebarItems.find((item) => {
		const permissions = (Array.isArray(item.permission) ? item.permission : item.permission ? [item.permission] : []).filter((p) => p !== '');
		return permissions.length === 0 || userPermissions.hasPermissions(permissions);
	});
	if (firstAllowed) {
		return router.parseUrl(`/${firstAllowed.path}`);
	}

	sessionStorage.setItem('Link.Illegal', 'x');
	return router.parseUrl('/core');
};
